import { FC } from 'react'
import { Link } from 'react-router-dom'
import { KTIcon } from '../../_metronic/helpers'
import { useAuth } from '../modules/auth'

/**
 * A reminder in the header for an account that signs in with a password alone. Shown only when the
 * server said so explicitly — never while the account is unknown.
 */
export const SecondFactorWarning: FC = () => {
  const { currentUser } = useAuth()

  if (currentUser?.secondFactorEnabled !== false) {
    return null
  }

  return (
    <Link
      to='/account'
      className='badge badge-light-warning d-inline-flex align-items-center gap-2 fs-7 py-2 px-3 text-hover-primary'
      title='Вход защищён только паролем. Подключите второй фактор на странице учётной записи.'
    >
      <KTIcon iconName='shield-cross' className='fs-3 text-warning' />
      <span>Второй фактор не включён</span>
    </Link>
  )
}
